module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/thai-34b5184ed551e8e43b97074971fffa4dec6a16a29d17ebcd4fb2e33901b820bd.png";